import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MisconfiguredVoiceAppReport } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class MisconfiguredVoiceAppsResource {
  private _http = inject(HttpClient);

  get(tenantId: string): Observable<MisconfiguredVoiceAppReport> {
    return this._http.get<MisconfiguredVoiceAppReport>(
      `/services/microsoft/reporting/tenants/${tenantId}/misconfigured-voice-apps`,
    );
  }
}
